export enum LineCapTypes {
    BUTT = 'butt',
    ROUND = 'round',
    SQUARE = 'square',
}
